module.exports = __webpack_public_path__ + "img/WS.54c94e5c.png";